import React, { useState } from 'react';
import '../../../assets/css/chat.css';

const ChatInput = ({ onSendMessage }) => {
    const [text, setText] = useState('');
    
    const onChange = (e) => {
        setText(e.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        setText('');
        onSendMessage(text);
    }

    return (
        <div className="chat-input-form">
            <form onSubmit={e => onSubmit(e)}>
                <input
                    className="chat-input"
                    onChange={e => onChange(e)}
                    value={text}
                    type="text"
                    placeholder="Enter your message and press ENTER"
                    autoFocus={true} />
                <button className="send-button">
                    <i className="fa fa-paper-plane"></i>
                </button>
            </form>
        </div>
    );
}

export default ChatInput;
